export const PasswordMaxLength = 100;
export const PasswordMinLength = 8;
export const UsernameMaxLength = 50;
export const UsernameMinLength = 1;
export const PasswordSpecialCharacters = ' !"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~';
